<div class="w-full flex flex-col flex-1 min-h-0">
<div class="flex flex-col flex-1 min-h-0 overflow-hidden">

  @if (loading() && !initialLoadDone()) {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <p-skeleton width="8rem" height="1.5rem" class="mb-2" />
            <p-skeleton width="14rem" height="0.875rem" />
          </div>
          <div class="w-full sm:w-auto flex justify-end">
            <p-skeleton width="10rem" height="2.5rem" />
          </div>
        </div>
      </div>
      <div class="flex-1 min-h-0 overflow-auto">
        <table class="w-full border-collapse">
          <thead class="bg-slate-50 border-b border-slate-200">
            <tr>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Folio</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Cliente</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Producto</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Estado</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">F. creación</th>
              <th class="px-2 py-2 text-right text-sm font-semibold text-slate-600">Total</th>
              <th class="px-2 py-2 text-left text-sm font-semibold text-slate-600">Acciones</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-slate-100">
            @for (row of skeletonRows; track row) {
              <tr>
                <td class="px-2 py-2">
                  <div class="flex items-center gap-2">
                    <p-skeleton shape="circle" size="2rem" />
                    <p-skeleton width="6rem" height="0.875rem" />
                  </div>
                </td>
                <td class="px-2 py-2"><p-skeleton width="8rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="7rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="4rem" height="1.25rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2 text-right"><p-skeleton width="2rem" height="2rem" /></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }

  @if (error() && !loading()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <div class="flex items-center">
        <mat-icon class="text-red-600 mr-2">error</mat-icon>
        <p class="text-red-800">{{ error() }}</p>
      </div>
      <button
        type="button"
        (click)="load()"
        class="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
        Reintentar
      </button>
    </div>
  }

  @if (initialLoadDone() && !error()) {
    <div class="flex-1 min-h-0 flex flex-col">
      <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
                  <i class="pi pi-link"></i>
                </span>
                Ligas de pago
              </h2>
              <p class="text-sm text-slate-500 mt-1">Cobros que no generan venta hasta que se pagan.</p>
            </div>
            <div class="w-full sm:w-auto flex flex-wrap items-center justify-end gap-2">
              <p-button
                label="Actualizar"
                icon="pi pi-refresh"
                severity="secondary"
                size="small"
                [rounded]="true"
                [loading]="loading()"
                (onClick)="load()"
                pTooltip="Actualizar listado con los filtros y página actuales"
                tooltipPosition="left"
                appendTo="body" />
              <a routerLink="/sale-links/nuevo" class="inline-block" appDisableUnless="SALE_LINK_WRITE">
                <p-button label="Nueva liga" icon="pi pi-plus" severity="primary" size="small" appDisableUnless="SALE_LINK_WRITE" />
              </a>
            </div>
          </div>
        </div>

        <div [formGroup]="filtersForm" class="border-b border-slate-200 bg-slate-50 shrink-0 px-3 py-2">
          <div class="grid grid-cols-2 xl:flex xl:flex-wrap xl:items-end gap-2">
            <p-floatlabel class="w-full min-w-0 xl:w-40" variant="on">
              <p-select
                formControlName="type"
                inputId="saleLinkType"
                [options]="typeOptions"
                optionLabel="label"
                optionValue="value"
                size="small"
                [showClear]="true"
                class="w-full" />
              <label for="saleLinkType">Tipo</label>
            </p-floatlabel>
            <div class="min-w-0 col-span-2 sm:col-span-1 xl:flex-1 xl:min-w-48">
              <p-floatlabel class="w-full" variant="on">
                <p-autocomplete
                  inputId="saleLinkCustomer"
                  formControlName="customer"
                  [suggestions]="customerOptions()"
                  (completeMethod)="onCustomerSearch($event)"
                  (onSelect)="applyFilters()"
                  (onClear)="applyFilters()"
                  optionLabel="displayLabel"
                  [minLength]="3"
                  [showClear]="true"
                  size="small"
                  fluid
                  appendTo="body">
                  <ng-template #item let-customer>
                    <div class="flex flex-col py-0.5">
                      <span class="text-sm font-medium text-slate-900 leading-snug">{{ customer.comercialName || customer.legalName }}</span>
                      <span class="text-xs text-slate-400 leading-snug">{{ customer.taxId }}</span>
                    </div>
                  </ng-template>
                </p-autocomplete>
                <label for="saleLinkCustomer">Cliente</label>
              </p-floatlabel>
            </div>
            <div class="min-w-0 xl:w-28">
              <p-floatlabel class="w-full" variant="on">
                <p-iconfield class="w-full">
                  <input pInputText id="saleLinkSerie" formControlName="serie" class="w-full p-inputtext-sm" autocomplete="off" />
                  @if (filtersForm.controls.serie.value) {
                    <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.serie.setValue('', { emitEvent: false }); applyFilters()" />
                  }
                </p-iconfield>
                <label for="saleLinkSerie">Serie</label>
              </p-floatlabel>
            </div>
            <p-floatlabel class="w-full min-w-0 col-span-2 sm:col-span-1 xl:w-64" variant="on">
              <p-datepicker
                inputId="saleLinkCreatedAt"
                formControlName="createdAtRange"
                selectionMode="range"
                [readonlyInput]="true"
                dateFormat="dd/mm/yy"
                showIcon
                iconDisplay="input"
                [showClear]="true"
                size="small"
                appendTo="body"
                class="w-full" />
              <label for="saleLinkCreatedAt">Rango F. creación</label>
            </p-floatlabel>
            <p-floatlabel class="w-full min-w-0 xl:w-40" variant="on">
              <p-select
                formControlName="status"
                inputId="saleLinkStatus"
                [options]="statusOptions"
                optionLabel="label"
                optionValue="value"
                size="small"
                [showClear]="true"
                class="w-full" />
              <label for="saleLinkStatus">Estado</label>
            </p-floatlabel>
            @if (hasActiveFilters()) {
              <div class="flex items-end">
                <p-button
                  icon="pi pi-times"
                  [rounded]="true"
                  [text]="true"
                  size="small"
                  severity="secondary"
                  type="button"
                  (onClick)="clearFilters()"
                  ariaLabel="Limpiar filtros" />
              </div>
            }
          </div>
        </div>

        <div class="flex-1 min-h-0 overflow-hidden">
          <p-table
            [value]="links()"
            dataKey="id"
            [lazy]="true"
            [scrollable]="true"
            scrollHeight="flex"
            [totalRecords]="totalItems()"
            [first]="currentPage() * pageSize()"
            [rows]="pageSize()"
            [rowsPerPageOptions]="pageSizeOptions"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} ligas"
            [loading]="loading()"
            [paginator]="true"
            sortMode="single"
            [sortField]="sortField()"
            [sortOrder]="sortOrder()"
            (onLazyLoad)="onLazyLoad($event)"
            [tableStyle]="{ width: '100%' }"
            styleClass="sale-links-primeng-table p-datatable-striped p-datatable-sm"
            [rowHover]="true"
            paginatorStyleClass="!border-0 !bg-transparent !pt-4 !flex !items-center !justify-between">
            <ng-template pTemplate="header">
              <tr>
                <th class="!px-2" pSortableColumn="number">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Folio</span>
                    @if (sortField() === 'number') {
                      <p-sortIcon field="number" />
                    }
                  </span>
                </th>
                <th class="!px-2">Cliente</th>
                <th class="!px-2 hidden sm:table-cell">Producto</th>
                <th class="!px-2 !whitespace-nowrap" pSortableColumn="status">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Estado</span>
                    @if (sortField() === 'status') {
                      <p-sortIcon field="status" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap !text-center" pSortableColumn="createdAt">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>F. creación</span>
                    @if (sortField() === 'createdAt') {
                      <p-sortIcon field="createdAt" />
                    }
                  </span>
                </th>
                <th class="!px-2 hidden sm:table-cell !whitespace-nowrap !text-center">Vigencia</th>
                <th class="!px-2 !whitespace-nowrap !text-right">Total</th>
                <th class="!px-2 !whitespace-nowrap !text-right">Acciones</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-link>
              <tr class="cursor-pointer hover:!bg-sky-50/50 transition-colors !border-slate-100" (click)="openDetails(link)">
                <td class="!px-2 !py-2 !border-slate-100">
                  <div class="flex items-center gap-2">
                    <div
                      [class]="statusIconClasses(link.status) + ' !h-8 !w-8 [&>i]:text-sm'"
                      [pTooltip]="statusLabel(link.status)"
                      tooltipPosition="top">
                      <i [class]="statusIcon(link.status)"></i>
                    </div>
                    <div class="min-w-0">
                      <div class="text-sm font-medium text-slate-900 truncate">{{ link.number || '—' }}</div>
                      <span class="block text-[11px] text-slate-400 mt-0.5 font-normal">{{ typeLabel(link.type) }}</span>
                    </div>
                  </div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 max-w-[12rem]">
                  <div class="min-w-0">
                    <div class="text-sm text-slate-900 truncate">{{ link.customerName || '—' }}</div>
                    <div class="text-xs text-slate-500 truncate">{{ link.customerTaxId || '' }}</div>
                  </div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 hidden sm:table-cell max-w-[12rem]">
                  <div class="text-sm text-slate-900 truncate">{{ link.productName || '—' }}</div>
                  <div class="text-xs text-slate-500 truncate">{{ link.productSku || '' }}</div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap">
                  <p-tag class="!text-xs" [severity]="statusSeverity(link.status)" [value]="statusLabel(link.status)" />
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap !text-center">
                  @if (link.createdAt) {
                    <div class="text-sm text-slate-600">{{ link.createdAt | date:'dd/MM/yyyy' }}</div>
                    <div class="text-[11px] text-slate-400 mt-0.5">{{ link.createdAt | date:'h:mm a' }}</div>
                  } @else {
                    <span class="text-sm text-slate-600">-</span>
                  }
                </td>
                <td class="!px-2 !py-2 !border-slate-100 hidden sm:table-cell !whitespace-nowrap !text-center">
                  @if (link.expiresAt) {
                    <div class="text-sm text-slate-600">{{ link.expiresAt | date:'dd/MM/yyyy' }}</div>
                    <div class="text-[11px] text-slate-400 mt-0.5">{{ link.expiresAt | date:'h:mm a' }}</div>
                  } @else {
                    <span class="text-sm text-slate-400">Sin vigencia</span>
                  }
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-900 !whitespace-nowrap !text-right">
                  {{ (link.currentTotal ?? link.unitPrice ?? 0) | currency:(link.currencyCode || 'MXN'):'symbol':'1.2-2' }}
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !text-right !whitespace-nowrap">
                  <p-button
                    icon="pi pi-pencil"
                    [rounded]="true"
                    [text]="true"
                    severity="secondary"
                    styleClass="hover:!bg-sky-100"
                    pTooltip="Editar"
                    tooltipPosition="top"
                    (onClick)="edit($event, link)" />
                  <p-button
                    icon="pi pi-send"
                    [rounded]="true"
                    [text]="true"
                    severity="secondary"
                    styleClass="hover:!bg-sky-100"
                    pTooltip="Enviar liga de pago"
                    tooltipPosition="top"
                    [disabled]="link.status === 'CANCELLED' || link.status === 'PAID'"
                    (onClick)="openSendDialog($event, link)" />
                  <p-button
                    icon="pi pi-link"
                    [rounded]="true"
                    [text]="true"
                    severity="secondary"
                    styleClass="hover:!bg-sky-100"
                    pTooltip="Link de pago"
                    tooltipPosition="top"
                    (onClick)="showPaymentLink($event, link)" />
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="8" class="!px-2 !py-12 !text-center !text-slate-500 !border-slate-100">
                  No se encontraron ligas de pago con los filtros aplicados.
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  }

</div>
</div>

<p-drawer
  [visible]="detailsOpen()"
  position="right"
  (visibleChange)="onDrawerVisibleChange($event)"
  styleClass="sale-link-details-drawer !w-[800px]"
  [blockScroll]="true">
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full gap-3">
      <div class="flex items-center gap-3 min-w-0">
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600 shadow-sm">
          <i class="pi pi-link text-base"></i>
        </span>
        <h3 class="text-lg font-semibold text-slate-900">Detalle de liga de pago</h3>
      </div>
      @if (selectedLink() && !detailsLoading()) {
        <button
          type="button"
          class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
          (click)="editFromDrawer()">
          <i class="pi pi-pencil text-sm"></i>
          Editar
        </button>
      }
    </div>
  </ng-template>
  @if (detailsLoading()) {
    <div class="flex flex-col items-center justify-center py-12 gap-4">
      <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
      <p class="text-sm text-slate-600">Cargando detalle...</p>
    </div>
  } @else if (selectedLink()) {
    <app-sale-link-read [link]="selectedLink()!" />
  }
</p-drawer>

<p-dialog
  header="Enviar liga de pago"
  [visible]="sendDialogOpen()"
  (visibleChange)="sendDialogOpen.set($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="!sending()"
  [closable]="!sending()"
  appendTo="body"
  [style]="{ width: 'min(28rem, calc(100vw - 2rem))' }">
  <div class="flex flex-col gap-4 pt-1">
    <p class="text-sm text-slate-600 m-0">Indica el correo al que se enviará la liga de pago.</p>
    <p-floatlabel variant="on">
      <input
        pInputText
        id="send-sale-link-list-email"
        class="w-full"
        type="email"
        autocomplete="email"
        [value]="sendEmail()"
        (input)="sendEmail.set($any($event.target).value)"
        [disabled]="sending()" />
      <label for="send-sale-link-list-email">Correo electrónico</label>
    </p-floatlabel>
  </div>
  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button label="Cancelar" severity="secondary" [text]="true" type="button" [disabled]="sending()" (onClick)="sendDialogOpen.set(false)" />
      <p-button label="Enviar" icon="pi pi-send" type="button" [loading]="sending()" [disabled]="sending() || !sendEmail().trim()" (onClick)="submitSend()" />
    </div>
  </ng-template>
</p-dialog>
